import axios from 'axios'

const apiUrl = process.env.WEB_API_URL

export const axiosInstance = axios.create({
  baseURL: apiUrl,
})
